import type { TagCategory } from '../graphql/types';

/**
 * Fallback label for a tag whose `categoryId` matches no known `TagCategory`
 * (deleted/legacy category, or the category set simply hasn't loaded).
 * Matches the fallback bucket label used by `TagPicker`'s
 * `groupTagsByCategory` (issue #714) so "Uncategorized" means the same thing
 * everywhere a Tag Group name is shown.
 */
export const UNCATEGORIZED_TAG_CATEGORY_LABEL = 'Uncategorized';

/**
 * Resolves the display name of a tag's Tag Group (Tag Category), falling
 * back to `UNCATEGORIZED_TAG_CATEGORY_LABEL` when `categoryId` doesn't match
 * any entry in `categories` (issue #744).
 */
export function resolveTagCategoryName(
  categoryId: string,
  categories: readonly TagCategory[]
): string {
  return (
    categories.find((category) => category.entityId === categoryId)?.name ??
    UNCATEGORIZED_TAG_CATEGORY_LABEL
  );
}
